export default __webpack_public_path__ + "rpl_icon_light.0f04fade.svg";